import { Box, Typography } from '@mui/material';

import { FBoxContainer as LegacyFBoxContainer } from '../../../../../../components/base';
import { FBoxContainer } from '../../../../../../components/baseV2';
import ErrorAlertIcon from '../../../../../../components/svgs/ErrorAlertIcon';
import {
  FIRST_SECTION_SPACING_SX,
  LEGACY_SECTION_CONTENT_SX,
  LEGACY_SECTION_SUBTITLE_SX,
  LEGACY_SECTION_SX,
  LEGACY_SECTION_TITLE_SX,
  SECTION_DISABLED_SX,
  SECTION_ENABLED_SX,
  SECTION_ERROR_COLOR,
  SECTION_ERROR_SX,
  SECTION_ERROR_TEXT_SX,
} from '../styles';

import type { ChecklistSectionProps, SectionErrorProps } from '../types';

function SectionError({ message }: SectionErrorProps) {
  return (
    <Box sx={SECTION_ERROR_SX}>
      <ErrorAlertIcon color={SECTION_ERROR_COLOR} />
      <Typography sx={SECTION_ERROR_TEXT_SX}>{message}</Typography>
    </Box>
  );
}

export default function ChecklistSection({
  children,
  errorMessage,
  hasError,
  isFirst = false,
  session,
  subtitle,
  title,
  useNewUi,
}: ChecklistSectionProps) {
  if (!useNewUi) {
    return (
      <LegacyFBoxContainer
        sx={[
          LEGACY_SECTION_SX,
          isFirst ? FIRST_SECTION_SPACING_SX : null,
          session?.id ? SECTION_ENABLED_SX : SECTION_DISABLED_SX,
        ]}
        contentStyle={LEGACY_SECTION_CONTENT_SX}
      >
        <Typography sx={LEGACY_SECTION_TITLE_SX}>{title}</Typography>
        <Typography sx={LEGACY_SECTION_SUBTITLE_SX}>{subtitle}</Typography>
        {hasError ? <SectionError message={errorMessage} /> : null}
        {children}
      </LegacyFBoxContainer>
    );
  }

  return (
    <FBoxContainer
      title={title}
      subtitle={subtitle}
      required
      sx={[
        isFirst ? FIRST_SECTION_SPACING_SX : null,
        session?.id ? SECTION_ENABLED_SX : SECTION_DISABLED_SX,
      ]}
    >
      {hasError ? <SectionError message={errorMessage} /> : null}
      {children}
    </FBoxContainer>
  );
}
